import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

function subscribe(onChange) {
  const media = window.matchMedia(QUERY);
  media.addEventListener("change", onChange);
  // The accessibility panel's own switch is a class on <body>.
  const observer = new MutationObserver(onChange);
  observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
  return () => {
    media.removeEventListener("change", onChange);
    observer.disconnect();
  };
}

const snapshot = () =>
  window.matchMedia(QUERY).matches || document.body.classList.contains("reduced-motion");

/**
 * True when motion should stay off: the OS setting or the site's accessibility panel.
 * False while prerendering, and it follows either switch live.
 */
export function useReducedMotion() {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
